var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "status-badge mr-2", style: _vm.variant }, [
    _c("i", { staticClass: "fas mx-1", class: _vm.variant.icon }),
    _c("span", { staticClass: "mx-1" }, [_vm._v(_vm._s(_vm.title))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }